import { AnyAction } from 'redux'
import { cloneDeep } from 'lodash';
import Questionnaire from '../../models/core/questionnaire/Questionnaire';
import { FETCH_AVALIACAO, FETCH_QUESTIONARIO_HMV, FETCH_QUESTIONARIO_OMS, RESET_AVALIACAO } from '../actions/questionnaire';
import AvaliacaoResposta from '../../models/core/questionnaire/AvaliacaoResposta';
 
interface IQuestionnaireReducer{ 
  questionarioOMS: Questionnaire | null;
  questionarioHMV: Questionnaire | null;
  avaliacao: AvaliacaoResposta | null;
}
 
const initialState: IQuestionnaireReducer = {
    questionarioOMS: null,
    questionarioHMV: null,
    avaliacao: null
} 
 
export const QuestionnaireReducer = (state = initialState, action: AnyAction) =>{
   switch(action.type){
        case RESET_AVALIACAO:{
            return {
                ...cloneDeep(state),
                avaliacao: null,
            }
        }
        case FETCH_QUESTIONARIO_OMS:{
            return {
                ...cloneDeep(state),
                questionarioOMS: action.questionario
            }
        }
        case FETCH_AVALIACAO:{
            return {
                ...cloneDeep(state),
                avaliacao: action.avaliacao
            }
        }
        case FETCH_QUESTIONARIO_HMV:{
            return {
                ...cloneDeep(state),
                questionarioHMV: action.questionario
            }
        }
       default:{
           return state
       }
   }
}
 